/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * googleMapsSearchDirective creates a complete google map view base on the user's location, and finds and renders
 * the places near the him/her based on the given search_term
 *
 * NOTE: this directive requires the google maps directive and Google map script in the base template to load the Google Maps JS
 * API before this directive is initialized.
 *
 * @module enervee_utils.google_maps
 */
function googleMapsSearchDirective() {
    return {
        restrict: 'E',
        scope: {
            props: '<'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: googleMapsSearchController,
        template: require('./googleMapsSearchView.html')
    };
}

googleMapsSearchController.$inject = [
    '$log',
    'AnalyticsService',
    'UtilService',
    'CmsContentService',
    'GeoService',
    'CategoriesService'
];

function googleMapsSearchController(
    $log,
    AnalyticsService,
    UtilService,
    CmsContentService,
    GeoService,
    CategoriesService
) {

    this.$onInit = function () {

        let vm = this;
        const default_map_description_cms_key = "details_page:map_description";
        const default_map_open_cms_key = "details_page:open_map";
        const category = CategoriesService.getActiveCategory();
        const categoryId = category.id;

        vm.googleMapsDirectiveControl = {};

        vm.coordinates = null;
        vm.userZipCode = null;

        vm.mapsImageUrl = UtilService.getSiteSetting('details_page_maps_image_url');

        /**
         * Determines users coordinates
         */
        if (vm.props && vm.props.coordinates) {
            vm.coordinates = vm.props.coordinates;
        } else {
            GeoService.getUserLatLng().then(function (latLng) {
                vm.coordinates = {lat: latLng.lat, long: latLng.lng};
            }).catch(function (error) {
                return $log.warn(error);
            });
        }

        let mapDescriptionCmsKey = default_map_description_cms_key;
        let mapOpenCmsKey = default_map_open_cms_key;

        if (vm.props && vm.props.cms_keys) {
            if (vm.props.cms_keys.map_description) {
                mapDescriptionCmsKey = vm.props.cms_keys.map_description;
            }

            if (vm.props.cms_keys.map_open) {
                mapOpenCmsKey = vm.props.cms_keys.map_open;
            }
        }

        CmsContentService.retrieveCMSValue(vm, 'map_description', mapDescriptionCmsKey, {}, categoryId);
        CmsContentService.retrieveCMSValue(vm, 'map_open', mapOpenCmsKey, {}, categoryId);

        /**
         * Opens the google map and searches the given search term of the props object
         */
        vm.openMap = function () {

            trackMapEngaged();

            let mapQuery = "/maps?q=" + vm.props.search_term;
            if (vm.coordinates) {
                mapQuery += "&@" + vm.coordinates.lat + "," + vm.coordinates.long;
            }

            /**
             *  if we're on iOS, open in Apple Maps else use Google
             */
            if (/iPhone|iPad|iPod/.test(navigator.platform)) {
                window.open("maps://maps.google.com" + mapQuery);
            } else {
                window.open("https://maps.google.com" + mapQuery);
            }
        };

        /**
         * Tracks maps views whenever a user scrolls to the map view
         *
         * @return {null}
         */
        vm.trackMapViewed = function() {
            const trackingData = getLocationTrackingData();
            const products = getProductsForTracking();

            AnalyticsService.reportEvent('Map Viewed', trackingData , products);
        };

        /**
         * Tracks maps engagement whenever a user clicks on the map view button
         *
         * @return {null}
         */
        function trackMapEngaged() {
            const trackingData = getLocationTrackingData();
            const products = getProductsForTracking();

            AnalyticsService.reportEvent('Map Engaged', trackingData , products);
        }

        /**
         * Gets the location tracking data for the current user's
         *
         * @return {Array} location info to include in the tracking data
         */
        function getLocationTrackingData() {
            let zipCode = UtilService.getSiteSetting('default_utility_zip_code');
            if (vm.props.zip_code) {
                zipCode = vm.props.zip_code;
            }

            let trackingData = {
                zip: zipCode,
            };

            if (vm.coordinates) {
                trackingData.latitude = vm.coordinates.lat;
                trackingData.longitude = vm.coordinates.long;
            }

            return trackingData;
        }

        /**
         * Gets products that will be included in the tracking data
         *
         * @return {Array} products to include in the tracking data
         */
        function getProductsForTracking() {
            let products = [];
            if (vm.props.product) {
                products.push(vm.props.product);
            }
            return products;
        }
    };
}

module.exports = googleMapsSearchDirective;
